import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { checkForSelfAssign } from "@utilscommon";
import TicketAssign from "./ticket-assign-item";

const AssignTickets = (props) => {
  const {
    // parent
    formHasError,

    // own
    manageTicketsCount,
    eventUserCategories,
  } = props;
  // console.log("manageTicketsCount :- ", manageTicketsCount);

  const renderTicketAssign = () => {
    let returnHtml = [];
    let generalTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.type !== "addon";
    });
    let addonTicketsArr = _.filter(manageTicketsCount, (o) => {
      return o?.type === "addon";
    });

    let availableForSelfAssign = checkForSelfAssign(manageTicketsCount);
    let ticketarray = manageTicketsCount;
    let dynamicFormCommonSetting = [];
    if (availableForSelfAssign) {
      let usercategory = generalTicketsArr?.[0]?.usercategory;
      if (eventUserCategories?.data) {
        let matchCat = _.filter(eventUserCategories.data, (obj) => {
          return parseInt(obj.id) === parseInt(usercategory);
        });
        dynamicFormCommonSetting =
          matchCat?.length > 0
            ? JSON.parse(matchCat?.[0]?.commonsetting ?? "{}")
            : [];
      }
      ticketarray = [...generalTicketsArr, ...addonTicketsArr]; // sorting the tickets list according to the general ticket always comes first
    }
    const emailOptional = dynamicFormCommonSetting?.emailoptional ?? false; // Dynamic form email is optional setting, Validate email field as per setting
    // availableForSelfAssign && !emailOptional ? true : false; // Key used for allowing addon ticket's email field to put data. If general ticket email field is not optional then allow genreal ticket email in addon ticket, else allown buyer to add onother email in addon ticket.
    let availableForSelfAssignAndEmailMandatory = false;
    if (availableForSelfAssign) {
      availableForSelfAssignAndEmailMandatory = !emailOptional;
    }

    _.forEach(ticketarray, (item) => {
      let tid = item?.ticketid;
      let qty = item?.noofchildtickets
        ? item?.noofchildtickets
        : item?.quantity;

      for (let i = 0; i < qty; i++) {
        item.index = i;
        item.position = 1 + i;
        let finalitem = JSON.parse(JSON.stringify(item));

        returnHtml.push(
          <TicketAssign
            key={`tickets_key_${tid}_${i}`}
            form={`TicketAssignForm_${tid}_${i}`}
            assign={finalitem}
            formHasError={formHasError}
            availableForSelfAssign={availableForSelfAssign}
            availableForSelfAssignAndEmailMandatory={
              availableForSelfAssignAndEmailMandatory
            }
            addonTicketsArr={addonTicketsArr}
          />
        );
      }
    });

    return returnHtml;
  };

  return (
    <>
      {manageTicketsCount?.length > 0 ? (
        <ul className="space-y-3">{renderTicketAssign()}</ul>
      ) : (
        ""
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    manageTicketsCount: state.manageTicketsCount,
    eventUserCategories: state?.eventUserCategories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignTickets);
